import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const OkSmile = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 64 64"
            fill={props.fill ? props.fill : 'none'}
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd" d="M32.5 4C17.036 4 4.5 16.536 4.5 32C4.5 47.464 17.036 60 32.5 60C47.964 60 60.5 47.464 60.5 32C60.5 16.536 47.964 4 32.5 4ZM0.5 32C0.5 14.3269 14.8269 0 32.5 0C50.1731 0 64.5 14.3269 64.5 32C64.5 49.6731 50.1731 64 32.5 64C14.8269 64 0.5 49.6731 0.5 32Z" 
            fill={props.color ? props.color : "white"} />
            <path d="M22.5 42L42.5 42" stroke={props.color ? props.color : "white"} strokeWidth="2" strokeLinecap="round" />
            <rect x="38.5" y="18" width="8" height="8" rx="4" fill={props.color ? props.color : "white"}/>
            <rect x="18.5" y="18" width="8" height="8" rx="4" fill={props.color ? props.color : "white"}/>
        </SvgStyled>
    );
};

export default OkSmile;